import { render } from "./BannerHero.vue?vue&type=template&id=6f6af4f9&lang=pug"
import script from "./BannerHero.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerHero.vue?vue&type=script&setup=true&lang=js"

import "./BannerHero.vue?vue&type=style&index=0&id=6f6af4f9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__